import React, {useState, useEffect, useContext, useRef} from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  Container,
  Typography,
  TextField,
  MenuItem,
  CircularProgress,
} from '@material-ui/core/'
import CloseIcon from '@material-ui/icons/Close'
import ArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import {Mutation} from 'react-apollo'
import {barcodeSheetQuery} from '../../graphql/barcode/queries/barcodeSheetQuery'
import {createEditBarcodeSheet} from '../../graphql/barcode/mutations/barcodeSheetMutation'
import {libraryPageQuery} from '../../graphql/barcode/queries/libraryPageQuery'
import {useTranslation} from 'react-i18next'

import useStyles from './BarcodeCreateSheet.styles'
import {ToastMessageContext} from '../../context/ToastMessage'

function BarcodeCreateScreen(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [disableButton, setDisableButtons] = useState(false)
  const [formValues, setFormValues] = useState({
    name: '',
    pageSize: 'Letter',
    unit: 'in',
    pageWidth: 8.5,
    pageHeight: 11,
    topMargin: 0.5,
    bottomMargin: 0.5,
    leftMargin: 0.25,
    rightMargin: 0.25,
    rows: 10,
    rowGutter: 0,
    columns: 4,
    columnGutter: 0,
  })
  const [nameError, setNameError] = useState(false)
  const [rowError, setRowError] = useState(false)
  const [columnError, setColumnError] = useState(false)
  // const [showError, setShowError] = useState(false)
  const [updateTemplate, setUpdateTemplate] = useState(false)
  const [labelWidth, setLabelWidth] = useState(2.0)
  const [labelHeight, setLabelHeight] = useState(1.0)
  // const [errorMessage, setErrorMessage] = useState('')
  // const [btnTarget, setBtnTarget] = useState(null)
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const userId = parseInt(window.localStorage.getItem('user_id'))
  const toast = useContext(ToastMessageContext)
  const refBtnSave = useRef(null)

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  function closeDrawer(event) {
    props.toggleDrawer(false)
  }

  function drawerTitle() {
    let title = t('barcode.wizard.create-barcode-sheet.create-sheet')
    let subTitle = t('barcode.wizard.create-barcode-sheet.create-details')

    return (
      <div>
        <Typography variant="h6">{title}</Typography>
        <Box fontSize={12} fontWeight={200} marginTop={2} marginBottom={3}>
          {subTitle}
        </Box>
      </div>
    )
  }

  const handleChange = textField => event => {
    let value = event.target.value
    if (textField === 'pageSize') {
      if (value === 'Letter') {
        setFormValues({
          ...formValues,
          [textField]: value,
          unit: 'in',
          pageWidth: 8.5,
          pageHeight: 11,
        })
      } else if (value === 'A4') {
        setFormValues({
          ...formValues,
          [textField]: value,
          unit: 'mm',
          pageWidth: 210,
          pageHeight: 297,
        })
      } else {
        setFormValues({
          ...formValues,
          [textField]: value,
        })
      }
    } else {
      if (
        textField !== 'name' &&
        textField !== 'pageSize' &&
        textField !== 'unit' &&
        value === ''
      ) {
        value = 0
      }

      setFormValues({
        ...formValues,
        [textField]: value,
      })
    }
    labelWidthHeightCalculation(textField, value)
  }

  function labelWidthHeightCalculation(field, value) {
    formValues[field] = value

    let w = 0
    let h = 0
    if (value === 'A4') {
      w = 210
      h = 297
    } else if (value === 'Letter') {
      w = 8.5
      h = 11
    } else {
      w = formValues.pageWidth
      h = formValues.pageHeight
    }

    setLabelWidth(
      (
        (w -
          formValues.leftMargin -
          formValues.rightMargin -
          (formValues.columns - 1) * formValues.columnGutter) /
        formValues.columns
      ).toFixed(4)
    )
    setLabelHeight(
      (
        (h -
          formValues.topMargin -
          formValues.bottomMargin -
          (formValues.rows - 1) * formValues.rowGutter) /
        formValues.rows
      ).toFixed(4)
    )
  }

  function handleSave(barcodeSheet, event) {
    if (checkValidity()) {
      barcodeSheet({
        variables: {
          accountId: parseInt(props.accountId),
          name: formValues.name,
          size: formValues.pageSize,
          unit: formValues.unit,
          width: parseFloat(formValues.pageWidth),
          height: parseFloat(formValues.pageHeight),
          topMargin: parseFloat(formValues.topMargin),
          bottomMargin: parseFloat(formValues.bottomMargin),
          leftMargin: parseFloat(formValues.leftMargin),
          rightMargin: parseFloat(formValues.rightMargin),
          rows: parseInt(formValues.rows),
          columns: parseInt(formValues.columns),
          rowGutter: parseFloat(formValues.rowGutter),
          columnGutter: parseFloat(formValues.columnGutter),
        },
      })
      setDisableButtons(true)
      setUpdateTemplate(true)
    }
  }

  function checkValidity() {
    let errorMessage = ''
    if (formValues.name === '') {
      errorMessage = t('barcode.wizard.create-barcode-sheet.error-name-blank')
      setNameError(true)
    } else if (parseInt(formValues.rows) === 0 || parseInt(formValues.columns) === 0) {
      errorMessage = t('barcode.wizard.create-barcode-sheet.rows-column-error')
      setRowError(parseInt(formValues.rows) === 0)
      setColumnError(parseInt(formValues.columns) === 0)
    } else if (formValues.rows < 0 || formValues.columns < 0) {
      errorMessage = t('barcode.wizard.create-barcode-sheet.rows-column-negative')
      setRowError(formValues.rows < 0)
      setColumnError(formValues.columns < 0)
    }

    if (errorMessage === '') {
      return true
    } else {
      toast.popMessage(errorMessage, 'error', refBtnSave.current)
      return false
    }
  }

  function checkDataErrors(data) {
    setDisableButtons(false)
    setUpdateTemplate(false)
    if (data['createEditBarcodeSheet']['errors'].length > 0) {
      setNameError(true)
      toast.popMessage(
        t('barcode.wizard.create-barcode-sheet.error-name-taken'),
        'error',
        refBtnSave.current
      )
    } else {
      props.toggleDrawer(true)
      props.selectSheetCreate(data['createEditBarcodeSheet']['barcodeSheet'])
    }
  }

  return (
    <div className={classes.list} role="presentation">
      <Grid container>
        <Grid container item xs={9} justify="flex-start">
          <Button className={classes.backBtn} onClick={closeDrawer} disabled={disableButton}>
            <ArrowLeftIcon />
            {t('barcode.wizard.create-barcode-sheet.back-to-wizard')}
          </Button>
        </Grid>

        <Grid container item xs={3} justify="flex-end">
          <IconButton className={classes.buttonLink} onClick={closeDrawer} disabled={disableButton}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Container>
        {drawerTitle()}
        <Grid container spacing={2}>
          <Grid container item xs={12}>
            <TextField
              id="name"
              label={t('barcode.wizard.create-barcode-sheet.name')}
              value={formValues.name}
              fullWidth
              variant="outlined"
              onChange={handleChange('name')}
              error={nameError}
              disabled={updateTemplate}
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-select-sheet-size"
              select
              label={t('barcode.wizard.create-barcode-sheet.page-size')}
              className={classes.menuBar}
              value={formValues.pageSize}
              fullWidth={true}
              onChange={handleChange('pageSize')}
              SelectProps={{
                MenuProps: {
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                },
              }}
              variant="outlined"
            >
              {['Letter', 'A4', 'Custom'].map(sheetSize => (
                <MenuItem key={sheetSize} value={sheetSize}>
                  {sheetSize}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-select-sheet-unit"
              select
              label={t('barcode.wizard.create-barcode-sheet.unit')}
              className={classes.menuBar}
              value={formValues.unit}
              fullWidth={true}
              onChange={handleChange('unit')}
              SelectProps={{
                MenuProps: {
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                },
              }}
              variant="outlined"
              disabled={formValues.pageSize === 'Letter' || formValues.pageSize === 'A4'}
            >
              {['in', 'mm'].map(sheetUnit => (
                <MenuItem key={sheetUnit} value={sheetUnit}>
                  {sheetUnit}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-width"
              label={t('barcode.wizard.create-barcode-sheet.page-width')}
              type="number"
              value={formValues.pageWidth}
              fullWidth={true}
              onChange={handleChange('pageWidth')}
              variant="outlined"
              disabled={formValues.pageSize === 'Letter' || formValues.pageSize === 'A4'}
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-height"
              label={t('barcode.wizard.create-barcode-sheet.page-height')}
              type="number"
              value={formValues.pageHeight}
              fullWidth={true}
              onChange={handleChange('pageHeight')}
              variant="outlined"
              disabled={formValues.pageSize === 'Letter' || formValues.pageSize === 'A4'}
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-top-margin"
              label={t('barcode.wizard.create-barcode-sheet.top-margin')}
              type="number"
              value={formValues.topMargin}
              fullWidth={true}
              onChange={handleChange('topMargin')}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-bottom-margin"
              label={t('barcode.wizard.create-barcode-sheet.bottom-margin')}
              type="number"
              value={formValues.bottomMargin}
              fullWidth={true}
              onChange={handleChange('bottomMargin')}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-left-margin"
              label={t('barcode.wizard.create-barcode-sheet.left-margin')}
              type="number"
              value={formValues.leftMargin}
              fullWidth={true}
              onChange={handleChange('leftMargin')}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-right-margin"
              label={t('barcode.wizard.create-barcode-sheet.right-margin')}
              type="number"
              value={formValues.rightMargin}
              fullWidth={true}
              onChange={handleChange('rightMargin')}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-row"
              label={t('barcode.wizard.create-barcode-sheet.rows')}
              type="number"
              value={formValues.rows}
              fullWidth={true}
              onChange={handleChange('rows')}
              error={rowError}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-row-gutter"
              label={t('barcode.wizard.create-barcode-sheet.row-gutter')}
              type="number"
              value={formValues.rowGutter}
              fullWidth={true}
              onChange={handleChange('rowGutter')}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-columns"
              label={t('barcode.wizard.create-barcode-sheet.columns')}
              type="number"
              value={formValues.columns}
              fullWidth={true}
              onChange={handleChange('columns')}
              error={columnError}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-page-row-gutter"
              label={t('barcode.wizard.create-barcode-sheet.column-gutter')}
              type="number"
              value={formValues.columnGutter}
              fullWidth={true}
              onChange={handleChange('columnGutter')}
              variant="outlined"
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-label-width"
              label={t('barcode.wizard.create-barcode-sheet.label-width')}
              type="number"
              value={labelWidth}
              fullWidth={true}
              variant="outlined"
              disabled
            />
          </Grid>

          <Grid container item xs={6}>
            <TextField
              id="outlined-label-height"
              label={t('barcode.wizard.create-barcode-sheet.label-height')}
              type="number"
              value={labelHeight}
              fullWidth={true}
              variant="outlined"
              disabled
            />
          </Grid>
        </Grid>

        <Box marginTop={2} />
        <Grid container item xs={12}>
          <Mutation
            mutation={createEditBarcodeSheet}
            refetchQueries={() => [
              {
                query: barcodeSheetQuery,
                variables: {accountId: parseInt(props.accountId)},
              },
              {
                query: libraryPageQuery,
                variables: {
                  accountId: parseInt(props.accountId),
                  token: accessToken,
                  userId: userId,
                  filter: '',
                },
              },
            ]}
            awaitRefetchQueries
            onCompleted={data => checkDataErrors(data)}
          >
            {createEditBarcodeSheet => (
              <Button
                ref={refBtnSave}
                value="save-template"
                variant="contained"
                color="primary"
                fullWidth={true}
                onClick={e => handleSave(createEditBarcodeSheet, e)}
                disabled={updateTemplate}
                style={{textTransform: 'none'}}
              >
                {updateTemplate ? (
                  <div>
                    {t('barcode.wizard.create-barcode-sheet.creating')}
                    <CircularProgress size={20} color="secondary" />
                  </div>
                ) : (
                  <div>{t('barcode.wizard.create-barcode-sheet.save-template')}</div>
                )}
              </Button>
            )}
          </Mutation>
        </Grid>
        <Box marginTop={2} />
        <Grid container item xs={12} justify="flex-start">
          <Button
            value="save-template"
            variant="outlined"
            fullWidth={true}
            onClick={closeDrawer}
            disabled={disableButton}
            style={{textTransform: 'none'}}
          >
            {t('barcode.wizard.create-barcode-sheet.cancel')}
          </Button>
        </Grid>
        <Box marginBottom={5} />
      </Container>
    </div>
  )
}

export default BarcodeCreateScreen
